/** Lowercase hex sha256 (WebCrypto) of bytes or a Blob's bytes: the app's asset ids and content-object names. */
export async function sha256Hex(data: Blob | BufferSource): Promise<string> {
    const bytes = typeof (data as Blob).arrayBuffer === 'function' ? await (data as Blob).arrayBuffer() : (data as BufferSource);
    const digest = await crypto.subtle.digest('SHA-256', bytes);
    return Array.from(new Uint8Array(digest), (b) => b.toString(16).padStart(2, '0')).join('');
}
